<template>
  <div class="mr-region">
    <el-select
      v-model="province"
      :disabled="disabled"
      filterable
      clearable
      placeholder="请选择省"
      @clear="clearProvince"
      @change="provinceChange"
      style="width: 120px;"
    >
      <el-option
        v-for="(item, index) in provinceList"
        :key="index"
        :label="item.name"
        :value="item.id"
      />
    </el-select>
    &nbsp;&nbsp;
    <el-select
      v-model="city"
      :disabled="disabled"
      filterable
      clearable
      placeholder="请选择市"
      style="width: 120px;"
    >
      <el-option
        v-for="(item, index) in cityList"
        :key="index"
        :label="item.name"
        :value="item.id"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  name: "MrRegion",
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      province: "",
      city: "",
      provinceList: [],
      cityList: []
    }
  },
  mounted() {
    this.getProvince();
  },
  methods: {
    // 省
    getProvince() {
      this.request.getProvince().then((res) => {
        this.provinceList = res.data;
      });
    },
    // 市
    getCity() {
      this.request.getCity({ province: this.province }).then((res) => {
        this.cityList = res.data;
      });
    },
    provinceChange() {
     this.getCity();
    },
    clearProvince() {
      this.city = "";
    },
    emitData(changeValue) {
      this.$emit("changeRegion", changeValue)
    },
    reset() {
      this.province = "";
      this.city = "";
    }
  },
  watch: {
    province: {
      handler() {
        this.emitData({
          province: this.province,
          city: this.city,
        })
      }
    },
    city: {
      handler() {
        this.emitData({
          province: this.province,
          city: this.city,
        })
      }
    },
  }
};
</script>

<style></style>
